import React, { useState } from "react";
import { Notyf } from "notyf";

import BasicForm from "./basic-form";
import PasswordSelectForm from "./password-select-form";

const Wizard = () => {
  const [step, setStep] = useState(1);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);

  const [user, setUser] = useState({
    full_name: "",
    email: "",
    password: "",
    password_confirmed: false,
    loginMethod: "",
  });

  const handleNextStep = () => {
    if (step === 2) return;

    // Skip password selection if user is new
    if (!isNewUser && step == 1) {
      setStep(step + 2);
    } else {
      setStep(step + 1);
    }
  };

  const handlePreviousStep = () => {
    if (step === 1) return;

    setStep(step - 1);
  };

  const handleBasicFormSubmit = (vals) => {
    setUser({
      ...user,
      ...vals,
    });

    if (isNewUser) {
      handleNextStep();
    } else {
      handleConfirmationSubmit();
    }
  };

  const handleConfirmationSubmit = (vals) => {
    setFormSubmitting(true);

    if (isNewUser) {
      const updatedValues = {
        password: vals.password,
        password_confirmed: true,
      };

      setUser((prevState) => {
        return {
          ...prevState,
          ...updatedValues,
        };
      });
    } else {
      setUser((prevState) => {
        return {
          ...prevState,
        };
      });
    }

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": document.querySelector("meta[name='csrf-token']")
          .content,
      },
      body: JSON.stringify({
        user: {
          full_name: user.full_name,
          email: user.email,
          password: vals?.password,
        },
      }),
    };

    fetch("/api/v1/open_week_subscribers", options)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          const notyf = new Notyf({
            duration: 4000,
            position: {
              x: "right",
              y: "top",
            },
          });

          notyf.success("Cuenta creada exitosamente");

          window.location.href = "/open-week-24/bienvenido";
        }
      });
  };

  const renderSteps = () => {
    switch (step) {
      case 1:
        return (
          <BasicForm
            user={user}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
            handleBasicFormSubmit={handleBasicFormSubmit}
            setIsNewUser={setIsNewUser}
          />
        );
      case 2:
        return (
          <PasswordSelectForm
            user={user}
            handleNextStep={handleNextStep}
            formSubmitting={formSubmitting}
            handleConfirmationSubmit={handleConfirmationSubmit}
          />
        );
      default:
        return (
          <BasicForm
            user={user}
            handleNextStep={handleNextStep}
            handlePreviousStep={handlePreviousStep}
            handleBasicFormSubmit={handleBasicFormSubmit}
            setIsNewUser={setIsNewUser}
          />
        );
    }
  };

  return (
    <div>
      {/* <div className="w-full inline text-clip break-words">
        <p className="break-words">{JSON.stringify(user)}</p>
      </div> */}
      {renderSteps()}
    </div>
  );
};

export default Wizard;
